import React from "react";

const UnderConstruction = () => {
  return (
    <div>
      <h1>This Site is in Under Construction</h1>
    </div>
  );
};

export default UnderConstruction;
